import type { Theme } from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const QuoteMainStackStyle: StyleExtend<Theme> = {
  gap: {
    xs: 3,
    md: 5,
    lg: 7,
  },
  flexDirection: {
    xs: 'column',
    md: 'row',
  },
};

export const QuoteStatusToggleStyle: StyleExtend<Theme> = {
  'svg path': {
    fill: theme.palette.customColors.darkGray,
  },
};

export const QuoteStatusToggleSelectedStyle: StyleExtend<Theme> = {
  'svg path': {
    fill: theme.palette.customColors.copper,
  },
};

export const SecondaryButtonStyle: StyleExtend<Theme> = {
  border: 'none',
  backgroundColor: 'transparent',
  '&:hover': {
    background: 'unset',
    color: theme.palette.customColors.darkCopper,
  },
};

export const QuoteExtraInfoStackStyle: StyleExtend<Theme> = {
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderRadius: theme.spacing(0.5),
  p: theme.spacing(3),
  maxWidth: {
    md: '100%',
    lg: '410px',
  },
};

export const QuoteFeedbackInfoWrapperStackStyle: StyleExtend<Theme> = {
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderRadius: theme.spacing(0.5),
  p: theme.spacing(3),
  backgroundColor: theme.palette.customColors.lightBeige,
  maxWidth: {
    md: '100%',
    lg: '410px',
  },
  gap: theme.spacing(1),
};

export const QuoteFeedbackInfoStackStyle: StyleExtend<Theme> = {
  gap: theme.spacing(1.5),
  border: `1px solid ${theme.palette.customColors.cream}`,
  borderRadius: theme.spacing(0.5),
  p: theme.spacing(3),
  backgroundColor: theme.palette.common.white,
};

export const QuotePaymentContainerMobileStyle: StyleExtend<Theme> = {
  backgroundColor: theme.palette.customColors.lightBeige,
  borderTop: `1px solid ${theme.palette.customColors.lightGray}`,
  borderBottom: `1px solid ${theme.palette.customColors.lightGray}`,
  py: 2,
  mb: 2,
};

export const QuotePaymentContainerMobilePrimaryButtonStyle: StyleExtend<Theme> = {
  maxWidth: '107px',
  maxHeight: '52px',
};
